<template lang="pug">
.product-parts-content
  .product-parts-content-list.automotive(
    v-for='(item, index) in data',
    :key='index'
  )
    h3.product-parts-content-title {{ item.title }}
    .product-parts-content-inner
      .product-parts-content-item(
        v-for='(content, index) in item.content',
        :key='index'
      )
        .product-parts-content-logo
          img(v-for='(logo, index) in content.logo', :key='index', :src='logo')

        .product-parts-content-inner-item(
          v-for='(images, index) in content.items',
          :key='index'
        )
          .row
            .col(v-for='(image, index) in images.gallery', :key='index')
              img(:src='image.url', :class='image.description')
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      isLoading: false,
      data: [],
    }
  },
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData(loadMore = false) {
      this.isLoading = true

      // console.log(Object.assign({}, this.query))
      axios
        .get(`${THAIRUNG.api_endpoint}v1/page/product_parts`, {
          params: {
            type: 'automotive',
          },
        })
        .then(({ data }) => {
          this.data = data.data
        })
        .catch((error) => {})
        .then(() => {
          this.isLoading = false
        })
    },
  },
}
</script>